import React from 'react'
import type { SelectAsyncCreatableProps } from '../Select'
import { SelectAsyncCreatable } from '../Select/SelectAsyncCreatable'
import type { BaseCollaboratorSelectProps, CollaboratorSelectCreatableOption } from './CollaboratorSelect'
import { CollaboratorSelect } from './CollaboratorSelect'

export type CollaboratorSelectCreatableProps = BaseCollaboratorSelectProps &
  SelectAsyncCreatableProps<CollaboratorSelectCreatableOption, true> & {
    value?: CollaboratorSelectCreatableOption
  }

export const CollaboratorSelectCreatable = (props: CollaboratorSelectCreatableProps) => {
  return <CollaboratorSelect {...props} As={SelectAsyncCreatable} />
}
